export default __webpack_public_path__ + "static/media/portfolio-139.0d28f0df.jpg";